import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getSettingsPos } from '../index';

export const getPosTrackingMethodLocations = createSelector(
  getSettingsPos,
  get('trackingMethodLocations')
);

export const getPosLocationsByTrackingMethods = createSelector(
  getPosTrackingMethodLocations,
  get('locationsByTrackingMethod')
);

export const getPosLocationsForTrackingMethod = createSelector(
  (_, id) => id,
  getPosLocationsByTrackingMethods,
  get
);

export const getIsFetching = createSelector(
  getPosTrackingMethodLocations,
  get('fetching')
);
export const getIsFetched = createSelector(
  getPosTrackingMethodLocations,
  get('fetched')
);
export const getFetchingError = createSelector(
  getPosTrackingMethodLocations,
  get('fetchingError')
);

export const getIsSaving = createSelector(
  getPosTrackingMethodLocations,
  get('saving')
);
export const getIsSaved = createSelector(
  getPosTrackingMethodLocations,
  get('saved')
);
export const getSavingError = createSelector(
  getPosTrackingMethodLocations,
  get('savingError')
);

export const getIsDeleting = createSelector(
  getPosTrackingMethodLocations,
  get('deleting')
);
export const getIsDeleted = createSelector(
  getPosTrackingMethodLocations,
  get('deleted')
);
export const getDeletingError = createSelector(
  getPosTrackingMethodLocations,
  get('deletingError')
);
